module.exports = __webpack_public_path__ + "img/53.0e625b79.jpg";